module.exports = __webpack_public_path__ + "static/media/vaccine-info1.7ae05321.png";